enum ImageNameType {
  signature = 'signature',
  customer_image = 'customer_image',
  adjuster_image = 'adjuster_image',
}
enum ImageCulpritNameType {
  signature = 'signature',
  customer_image = 'customer_image',
  adjuster_image = 'adjuster_image',
  croquis_image = 'croquis_image',
}
export enum DamagedVehicleCorrectiveImageNameType {
  documents = 'documents',
  damaged_parts = 'damaged_parts',
  vehicle = 'vehicle',
}
enum AdjusterImageNameType {
  document_image = 'document_image',
  additional_image = 'additional_image',
  vehicle_image = 'vehicle_image',
  damaged_image = 'damaged_image',
}
export type ImageTabType = {
  name: ImageNameType;
  fa_name: string;
  editable: boolean;
  exists: boolean;
  label: { const: string; fa_const: string } | null;
  is_card_active: true;
  count: number;
};
export type ImageCulpritTabType = {
  name: ImageCulpritNameType;
  fa_name: string;
  editable: boolean;
  exists: boolean;
  label: { const: string; fa_const: string } | null;
  is_card_active: true;
  count: number;
};
export type DamagedVehicleCorrectiveImageTabType = {
  name: DamagedVehicleCorrectiveImageNameType;
  fa_name: string;
  editable: boolean;
  exists: boolean;
};

export type AdjusterImageTabType = {
  name: AdjusterImageNameType;
  fa_name: string;
  editable: boolean;
  exists: boolean;
  is_card_active: boolean;
};

export type GetPreviousCorrectiveImageResponse = {
  damaged: {
    id: string;
    title: { const: string; fa_const: string };
    part_id: number;
    side_id: number;
    side_name: { const: string; fa_const: string };
  }[];
  documents: { id: number; title: { const: string; fa_const: string } }[];
  vehicle: { id: number; title: { const: string; fa_const: string } }[];
};
